<template>
  <component :is="element" :class="props.class" v-bind="props" :style="style" :flex="flex">
    <slot></slot>
  </component>
</template>

<script lang="ts" setup>
interface DataTextProps {
  element?: string
  style?: { [key: string]: string }
  flex?: string
  props?: { [key: string]: any }
  class?: { [key: string]: string }
}
const props = withDefaults(defineProps<DataTextProps>(), {
  element: () => "div",
  style: () => ({}),
  flex: () => "",
  props: () => ({}),
  class: () => ({}),
})
</script>
<style lang="scss"></style>
